module.exports = __webpack_public_path__ + "img/pause.9e2059ce.svg";